import { useState } from 'react'
import { Col, Divider, Form, Radio, Row, Space, Typography } from 'antd'
import _, { set } from 'lodash'

import Card from 'components/Card'
import Table from 'components/Table'
import RiskMatrixChart from 'pages/MyIncident/components/Investigation/components/RiskMatrixChart'

import Styled from './styled'

import { useTranslate } from 'hooks/translate'

import { getReportHeaderTypeApi, getReportHeaderValueApi } from 'services/report_header_attr'
import { getRiskMatrixApi } from 'services/riskMatrix'
import { getSignificantApi } from 'services/significant'
import { getImpactTypeFilterListApi } from 'services/filter/impactType'
import { getReportStatusFilterListApi } from 'services/filter/reportStatus'
import { useAsync } from 'react-use'

export default function Investigation ({
  report_id,
  report_status,
  report_data,
  disabled,
  set_reportImpactLevel,
  set_reportOverall,
  setOpenReportOverall,
  isReportOwnself,
  reportImpactLevelHead,
  reportOverallHead,
  default_is_significant
}) {
  const { t } = useTranslate()

  const [canCalculate, setCalculate] = useState(false)
  const [changeSig, setChangeSig] = useState(false)
  const [isDefaultSignificant, setIsDefaultSignificant] = useState(true)
  const [isDisabled, setDisabled] = useState(false)
  const [loading, setLoading] = useState(false)
  const [likelihoodLevelOptions, setLikelihoodLevelOptions] = useState([])
  const [reportMatrixValue, setReportMatrixValue] = useState([])
  // Before Impact and Likelihood
  const [beforeRiskLevelId, setBeforeRiskLevelId] = useState(null)
  const [beforeImpactLevelId, setBeforeImpactLevelId] = useState(null)
  const [beforeImpactValue, setBeforeImpactValue] = useState(0)
  const [beforeLikelihoodLevelId, setBeforeLikelihoodLevelId] = useState(null)
  const [beforeLikelihoodValue, setBeforeLikelihoodValue] = useState(null)
  // Risk Significant
  const [significant, setSignificant] = useState(null)
  const [significantReport, setSignificantReport] = useState(null)
  const [significantDetails, setSignificantDetails] = useState([])
  const [checkSignificant, setCheckSignificant] = useState(false)
  // Overall
  const [impactTypeId, setImpactTypeId] = useState(null)
  const [overAllType, setOverAllType] = useState([])
  const [overAllImpactLevel, setOverAllImpactLevel] = useState([])
  const [overAllReport, setOverAllReport] = useState(reportOverallHead)
  // Max Before Impact Level
  const [maxBeforeImpact, setMaxBeforeImpact] = useState(0)

  const [filters, setFilters] = useState({
    param: null,
    is_active: true,
  })
  // Datasource for generate Impact Level each type
  const [dataSource, setDataSource] = useState([])
  // Array of Impact Level each type
  const [reportImpactLevel, setReportImpactLevel] = useState([])

  const columns = [
    {
      title: t('Impact Level of each types'),
      dataIndex: 'name',
      key: 'name',
      className: 'bold',
      width: 80,
    },
    {
      title: t('Impact Level'),
      className: 'bold',
      width: 300,
      render: (data) => {
        const find = _.find(reportImpactLevel, (item) => item.impact_type_id === data.id)
        const result = _.find(
          data.impactLevel,
          (item) => item.value === find.impact_level_before_id
        )
        return (
          <Form.Item
            rules={[
              isReportOwnself && beforeRiskLevelId === null
                ? {
                    required: true,
                    message: t('Please select at least 1 impact level'),
                  }
                : {
                    required: false,
                  },
            ]}
          >
            <Radio.Group
              value={result?.value}
              onChange={(e) => {
                const findData = _.find(data.impactLevel, (item) => item.value === e.target.value)
                getImpactLevelId(e.target.value, findData?.score, data, 'impact_level_before_id')
              }}
              disabled={disabled}
            >
              <Space direction='vertical'>
                {_.map(data.impactLevel, (item) => {
                  return (
                    <Radio
                      key={item.value}
                      value={item.value}
                      onClick={(e) => {
                        const findData = _.find(
                          data.impactLevel,
                          (item) => item.value === e.target.value
                        )
                        getImpactLevelId(null, findData?.score, data, 'impact_level_before_id')
                        setBeforeImpactLevelId(null)
                        setBeforeImpactValue(null)
                        setOverAllReport((prev) => ({
                          ...prev,
                          impact_level_before_id: null,
                        }))
                      }}
                    >
                      {item.label}
                    </Radio>
                  )
                })}
              </Space>
            </Radio.Group>
          </Form.Item>
        )
      },
    },
  ]

  const getReportMatrixValue = async () => {
    setLoading(true)
    const res = await getRiskMatrixApi(impactTypeId, filters)
    if (res.status === 'success') {
      const data = _.orderBy(res.data, ['likelihood_score', 'impact_score'], ['desc'])
      setReportMatrixValue(data)
    }
    setLoading(false)
  }

  const getOverAllType = async () => {
    setLoading(true)
    const res = await getImpactTypeFilterListApi()
    const overAllData = _.find(res.data, (item) => item.value_list_name === 'ภาพรวมของผลกระทบ')
    // Set ImpactTypeId for generate RiskMatrix
    setImpactTypeId(overAllData?.id)
    const headerType = await getReportHeaderTypeApi(filters)
    const findData = _.find(headerType.data, (item) => item.name === 'Impact Level')
    const impactLevel = await getReportHeaderValueApi(findData?.id, null, overAllData?.id, filters)
    const formatValue = _.map(impactLevel?.data?.items, (item) => {
      return { label: item.name, value: item.id, score: item.score }
    })
    if (overAllReport?.impact_level_before_id) {
      const beforeValue = _.find(
        formatValue,
        (item) => item.value === overAllReport?.impact_level_before_id
      )
      if (beforeValue) {
        setBeforeImpactLevelId(beforeValue.value)
        setBeforeImpactValue(beforeValue.score)
        setMaxBeforeImpact(beforeValue.score)
      }
    }
    setOverAllType(overAllData)
    setOverAllImpactLevel(formatValue)
    setLoading(false)
  }

  const getImpactType = async () => {
    const res = await getImpactTypeFilterListApi()
    const filterData = _.filter(res.data, (item) => item.value_list_code !== 'IT8')
    const headerType = await getReportHeaderTypeApi(filters)
    const findData = _.find(headerType.data, (item) => item.name === 'Impact Level')
    const temp = []
    const reportImpactLevel = []
    for (let i = 0; i < filterData.length; i++) {
      let impactLevel = await getReportHeaderValueApi(findData.id, null, filterData[i].id, filters)
      let mapData = _.map(impactLevel.data.items, (item) => {
        return { label: `${item.name}, ${item.description}`, value: item.id, score: item.score }
      })
      let formatData = {
        id: filterData[i].id,
        name: filterData[i].name,
        impactLevel: _.sortBy(mapData, 'score'),
      }
      const findReportData = _.find(report_data, (item) => item.impact_type_id === filterData[i].id)
      let formatReport = {
        impact_type_id: filterData[i].id,
        impact_level_before_id: findReportData?.impact_level_before_id || null,
        impact_level_after_id: findReportData?.impact_level_after_id || null,
      }
      temp.push(formatData)
      reportImpactLevel.push(formatReport)
    }
    setDataSource(temp)
    // set impact level each type
    if (reportImpactLevelHead.length > 0) {
      setReportImpactLevel(reportImpactLevelHead)
    } else {
      setReportImpactLevel(reportImpactLevel)
    }
    set_reportImpactLevel(reportImpactLevel)
  }

  const getLikelihoodLevelOptions = async () => {
    const headerType = await getReportHeaderTypeApi(filters)
    const findData = _.find(headerType.data, (item) => item.name === 'Likelihood Level')
    const headerValue = await getReportHeaderValueApi(findData?.id, null, null, filters)
    const formatValue = _.map(headerValue.data?.items, (item) => {
      return { label: `${item.name}, ${item.description}`, value: item.id, score: item.score }
    })
    if (overAllReport?.likelihood_level_before_id) {
      const beforeValue = _.find(
        formatValue,
        (item) => item.value === overAllReport?.likelihood_level_before_id
      )
      setBeforeLikelihoodLevelId(beforeValue?.value)
      setBeforeLikelihoodValue(beforeValue?.score)
    }
    setLikelihoodLevelOptions(_.sortBy(formatValue, 'score'))
  }

  const getRiskLevelId = async () => {
    const findData = _.find(
      reportMatrixValue,
      (item) =>
        item.impact_level_id === beforeImpactLevelId &&
        item.likelihood_level_id === beforeLikelihoodLevelId
    )
    setBeforeRiskLevelId(findData?.id)
    let is_significant = null
    if(significantReport){
      setSignificant(significantReport)
      is_significant = significantReport
    }else{
      if( canCalculate ){
        is_significant = findData?.is_significant == null? significantReport: findData.is_significant
        setSignificant(is_significant)
      } else {
        is_significant = default_is_significant == null? significantReport: default_is_significant
        setSignificant(is_significant)
      }
    }

    setOverAllReport((prev) => ({
      ...prev,
      risk_level_before_id: findData?.id,
      is_significant: is_significant
    }))

    set_reportOverall(overAllReport)
  }

  const getSignificant = async () => {
    const res = await getSignificantApi(report_id)
    if (res.status === 'success') {
      const significantDetail = _.filter(res.data.detail, (item) => _.find(item, 'is_significant'))
      // if (reportOverallHead.is_significant !== null) {
      //   setSignificant(reportOverallHead.is_significant)
      // } else 

      let is_significant = res.data?.is_significant

      if(isDefaultSignificant && default_is_significant != null){
        is_significant = default_is_significant
        setSignificant(default_is_significant)
        setSignificantReport(default_is_significant)
        setIsDefaultSignificant(false)
      }else if (res.data?.is_significant === 1) {
        setSignificant(true)
        setSignificantReport(true)
        is_significant = true
      } else {
        setSignificant(false)
        setSignificantReport(false)
        is_significant = false
      }

      setCheckSignificant(true)

      setOverAllReport((prev) => ({
        ...prev,
        is_significant: is_significant,
      }))
      
      const data = _.map(significantDetail, (items) => _.map(items, (item) => item.detail))
      let arr = _.reduce(data, (prev, curr) => {
        return prev.concat(curr)
      })

      setSignificantDetails(arr)
    }
  }

  const checkDisabled = async () => {
    //ถ้า incident disable ให้ทุกอย่างไม่สามารถแก้ไขได้
    if (disabled) {
      setDisabled(disabled)
    }
    //ถ้าไม่มี incident disable เช็ค report_status_id
    //ถ้าเป็น Draft, Awaiting checker approval, Awaiting rc approval ให้ disable after
    else {
      const res = await getReportStatusFilterListApi()
      const item = _.find(res?.data, (item) => item.id === report_status)
      if (
        item?.report_status_code === 'dft' ||
        item?.report_status_code === 'ara' ||
        item?.report_status_code === 'aca'
      )
        setDisabled(true)
    }
  }

  const getImpactLevelId = (value, score, record, text) => {
    setReportImpactLevel((data) => {
      let update = _.map(data, (item) => {
        if (item.impact_type_id === record.id) {
          return { ...item, [text]: value }
        } else {
          return item
        }
      })
      set_reportImpactLevel(update)
      return update
    })
  }

  useAsync(async () => {
    setOpenReportOverall()
    checkDisabled()
    getImpactType()
    getLikelihoodLevelOptions()
    getOverAllType()
    getSignificant()

    setCalculate(false)
  }, [])

  useAsync(async () => {
    if (impactTypeId) {
      getReportMatrixValue()
    }
  }, [impactTypeId])

  useAsync(async () => {
    
    if (beforeImpactLevelId && beforeLikelihoodLevelId) {
      getRiskLevelId()
    } else {
      setBeforeRiskLevelId(null)
      setOverAllReport((prev) => ({
        ...prev,
        risk_level_before_id: null
      }))
    }
    set_reportOverall(overAllReport)
  }, [beforeImpactLevelId, beforeLikelihoodLevelId, beforeRiskLevelId])

  useAsync(async () => {
    setOverAllReport((prev) => ({
      ...prev
    }))
    
    set_reportOverall(overAllReport)
  }, [changeSig])

  const findMaxScore = async () => {
    let tempId = 0,
      tempScore = 0
    for (let i = 0; i < reportImpactLevel.length; i++) {
      _.find(dataSource, (items) => {
        if (items.id === reportImpactLevel[i].impact_type_id) {
          const data = _.find(
            items.impactLevel,
            (item) => item.value === reportImpactLevel[i].impact_level_before_id
          )
          if (tempScore <= data?.score) {
            tempScore = data.score
          }
          const result = _.find(overAllImpactLevel, (item) => item.score === tempScore)
          tempId = result?.value
        }
      })
    }
    setBeforeImpactLevelId(tempId)
    setBeforeImpactValue(tempScore)
    setMaxBeforeImpact(tempScore)
    setOverAllReport((prev) => ({
      ...prev,
      impact_level_before_id: tempId,
    }))
  }

  useAsync(async () => {
    findMaxScore()
  }, [reportImpactLevel])

  return (
    <Styled className='investigation-component'>
      <Space size='middle' direction='vertical' style={{ width: '100%' }}>
        <Card title={t('Investigation')}>
          <Table
            loading={loading}
            dataSource={dataSource}
            columns={columns}
            pagination={false}
            tableLayout='fixed'
            scroll={{ x: 1200 }}
          />
          <Divider />
          <Row gutter={8} align='middle'>
            <Col xs={24} lg={12}>
              <Row justify='center'>
                <Typography.Title level={3}>{t(`${overAllType?.name}`)}</Typography.Title>
              </Row>
            </Col>
            <Col xs={24} lg={12}>
              <Row style={{ fontWeight: 'bold' }}>{t('Likelihood Level')}</Row>
              <Form.Item
                rules={[
                  isReportOwnself && beforeRiskLevelId === null
                    ? {
                        required: true,
                        message: t('Please select likelihood level'),
                      }
                    : {
                        required: false,
                      },
                ]}
              >
                <Radio.Group
                  style={{ marginBottom: 8 }}
                  value={beforeLikelihoodLevelId}
                  onChange={(e) => {
                    setCalculate(true)
                    const record = _.find(
                      likelihoodLevelOptions,
                      (item) => item.value === e.target.value
                    )
                    setBeforeLikelihoodValue(record.score)
                    setBeforeLikelihoodLevelId(e.target.value)
                    setOverAllReport((prev) => ({
                      ...prev,
                      likelihood_level_before_id: e.target.value,
                    }))
                  }}
                  disabled={disabled}
                >
                  <Space direction='vertical'>
                    {_.map(likelihoodLevelOptions, (item) => {
                      return (
                        <Radio
                          key={item.value}
                          value={item.value}
                          onClick={(e) => {
                            if (item.value === +e.target.value) {
                              setBeforeLikelihoodValue(null)
                              setBeforeLikelihoodLevelId(null)
                              setOverAllReport((prev) => ({
                                ...prev,
                                likelihood_level_before_id: null,
                              }))
                            }
                          }}
                        >
                          {item.label}
                        </Radio>
                      )
                    })}
                  </Space>
                </Radio.Group>
              </Form.Item>
              <Row style={{ fontWeight: 'bold' }}>{t('Impact Level')}</Row>
              <Radio.Group
                onChange={(e) => {
                  setCalculate(true)
                }}
                style={{ marginBottom: 8 }}
                options={overAllImpactLevel}
                value={beforeImpactLevelId}
                disabled
              />
              <Row gutter={8} align='middle'>
                <Col style={{ fontWeight: 'bold' }}>{t('Risk Score')} :</Col>
                <Col>
                  <Typography.Text>
                    {beforeImpactValue && beforeLikelihoodValue
                      ? beforeImpactValue * beforeLikelihoodValue
                      : 0}
                  </Typography.Text>
                </Col>
              </Row>
            </Col>
          </Row>
          <Divider />
          <Row gutter={8} justify='space-between' style={{ overflowX: 'auto' }}>
            <Col xs={24} lg={16}>
              <RiskMatrixChart
                reportMatrixValue={reportMatrixValue}
                loading={loading}
                beforeValue={beforeRiskLevelId}
              />
            </Col>
            <Col xs={24} lg={8}>
              <Row>
                <Typography.Text strong italic underline>
                  {t('Risk Significant')}
                </Typography.Text>
              </Row>
              <Radio.Group
                value={significant}
                onChange={(e) => {
                  setCalculate(true)
                  setSignificant(e.target.value)
                  if(changeSig){
                    setChangeSig(false)
                  }else{
                    setChangeSig(true)
                  }
                  
                  setOverAllReport((prev) => ({
                    ...prev,
                    is_significant: e.target.value,
                  }))
                }}
                disabled={disabled}
              >
                <Space direction='vertical'>
                  <Radio value={true}>{t('Significant Incident')}</Radio>
                  <Radio value={false}>{t('Non-significant Incident')}</Radio>
                </Space>
              </Radio.Group>
              <Row>
                {checkSignificant ? (
                  <Typography.Text strong italic underline style={{ marginTop: 8 }}>
                    {t('Risk Significant Details')}
                  </Typography.Text>
                ) : (
                  ''
                )}
              </Row>
              <Row>
                {checkSignificant ? (
                  <Space direction='vertical'>
                    {_.map(significantDetails, (item) => (
                      <Typography.Text key={item}>- {item}</Typography.Text>
                    ))}
                  </Space>
                ) : (
                  ''
                )}
              </Row>
            </Col>
          </Row>
        </Card>
      </Space>
    </Styled>
  )
}
